/*

jvShowPosition
==============

Position an element when it's shown.

 */

angular.module('jv.Common.Directives.ShowPosition',['jv.Common.Position'])
.directive('jvShowPosition', ['Position', '$timeout', function (Position, $timeout) {
	return {
		link: function (scope, elm, attrs) {
			var timer;

			if (!attrs.ngShow) {
				throw new Error('Ng-show is required to use jv-position.');
			}

			scope.$watch(attrs.ngShow, function(visible) {
				if (visible) {
					elm.css('visibility', 'hidden');
					timer = $timeout(function() {
						Position(elm, scope.$eval(attrs.jvShowPosition));
						elm.css('visibility', '');
					});
				}
				else {
					$timeout.cancel(timer);
				}
			});
		}
	};
}]);